import { useEffect } from 'react'

/**
 * This hook updates the overflow style property on the body element.
 *
 * Sets overflow to hidden when hideOverflow is true. Sets overflow to 'auto'
 * when hideOverflow is false and when component unmounts.
 */
export const useHideBodyOverflow = (hideOverflow: boolean) => {
  useEffect(() => {
    document.body.style.overflow = hideOverflow ? 'hidden' : 'auto'

    return (): void => {
      document.body.style.overflow = 'auto'
    }
  }, [hideOverflow])
}
